module.exports = __webpack_public_path__ + "static/media/Boat.7ae0c35c.png";